import { useUserInfo } from '~api'
import { regExp } from '~constants/regExp'

export const useRegisteredWithPhone = () => {
    const { data: userInfoData } = useUserInfo()

    let isRegisteredWithPhone = false
    let phoneNumber = undefined

    if (!userInfoData?.email && userInfoData?.phone) {
        phoneNumber = `${userInfoData?.phone?.country_code}${userInfoData?.phone?.number}`
        isRegisteredWithPhone = regExp.phone.test(phoneNumber)
    }

    return { isRegisteredWithPhone, phoneNumber, email: userInfoData?.email }
}
